import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Row
} from '@polichat/flamboyant';
import { useState } from 'react';
import { useGlotaT } from '../../../../../../hooks/useGlotaTranslation';
import { LabelWithSpan } from '../../FormMessagesBuilder.styles';

function CreateSectionList({
  id,
  onUpdate,
  removeSection,
  initialValue,
  isDisabledRemove,
}) {
  const [sectionData, setSectionData] = useState(initialValue);

  // Traduções
  const sectionLabel = useGlotaT('spa.messageBuilder.list.section.label');
  const sectionDescription = useGlotaT('spa.messageBuilder.list.section.description');
  const sectionPlaceholder = useGlotaT('spa.messageBuilder.list.section.placeholder');
  const removeSectionButton = useGlotaT('spa.messageBuilder.list.section.removeButton');

  const handleInputChange = ({ target: { name, value } }) => {
    setSectionData({
      ...sectionData,
      [name]: value,
    });
    handleSectionData({
      ...sectionData,
      [name]: value,
    });
  };

  const handleWithDeleteSection = () => {
    setSectionData({});
    removeSection(id);
  };

  const handleSectionData = (data) => {
    onUpdate(data);
  };

  return (
    <>
      <FormGroup>
        <LabelWithSpan>
          <Label>
            {sectionLabel}: <span>{sectionDescription}</span>
          </Label>
        </LabelWithSpan>
      </FormGroup>
      <Row>
        <Col sm={8} md={8}>
          <Input
            type="text"
            id="section-message"
            name="text"
            placeholder={sectionPlaceholder}
            value={sectionData.text}
            onChange={handleInputChange}
            showCharCounter
            maxLength={24}
            required
          />
        </Col>
        <Col sm={{ size: 2, offset: 0 }} md={{ size: 4, offset: 0 }}>
          <Button
            color="danger"
            onClick={handleWithDeleteSection}
            disabled={isDisabledRemove}
          >
            {removeSectionButton}
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default CreateSectionList;
